import { useState, useContext } from "react";
import { AuthContext } from "../../context/auth-context";
import { requestPartnerAPI } from "../../api/server";
import LoadingSpinner from "../UI/LoadingSpinner";
import { formatPhone } from "../../util/formatPhone";
import Heading from "../UI/Heading";
import { constructDateObject } from "../../util/format-date";

export default function Account({ setProgress }) {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = {
        name: e.target.name.value,
        phone: formatPhone(e.target.phone.value),
        email: user.email,
        code: e.target.code.value,
      };
      const dob = e.target.dob.value;
      payload.dob = constructDateObject(dob, "13:00:00");
      await requestPartnerAPI("create-partner", payload);
      setProgress((progress) => progress + 1);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={submitHandler}
      className="grid items-center content-start gap-4 lg:grid-cols-2"
    >
      <div className="lg:col-span-2">
        <Heading title="Account Setup" />
      </div>
      <div className="grid gap-1">
        <label className="form-label">Full Name:</label>
        <input className="form-input" name="name" required />
      </div>
      <div className="grid gap-1">
        <label className="form-label">Date of Birth:</label>
        <input className="form-input" name="dob" type="date"/>
      </div>

      <div className="grid gap-1">
        <label className="form-label">Phone Number:</label>
        <input className="form-input" name="phone" required />
      </div>
      <div className="grid gap-1">
        <label className="form-label">Email Address:</label>
        <input
          className="text-white form-input-disabled"
          value={user.email}
          disabled
        />
      </div>

      <div className="grid gap-1 md:col-span-2">
        <label className="form-label">Invitation Code:</label>
        <input className="form-input" name="code" required />
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <button type="submit" className="mt-4 text-sm btn-primary">
          Continue
        </button>
      )}
    </form>
  );
}
